import React, { useContext, useEffect, useState } from 'react';
import gql from 'graphql-tag';
import * as qs from 'query-string';
import { useQuery } from '@apollo/react-hooks';
import { useParams, useLocation } from 'react-router-dom';
import { Loading } from '../../../components/Loading';
import { growlErrors } from '../../../utils/NotificationUtil';
import { NotificationContext } from '../../../components/GrowlNotifications';
import BuySubscription from './BuySubscription';

const BUY_OR_REACTIVATE_CONFIG_QUERY = gql`
  query buyOrReactivateConfigQuery($accountId: ID!) {
    account(id: $accountId) {
      id
      type
      clientAccountsWithoutActiveSubscriptions {
        id
        displayName
        type
        subscriptionInformation {
          hasNoPreviousSubscription
          hasTrialPeriod
          freeTrialMonths
        }
      }
    }
  }
`;

const DEFAULT_MANAGING_ACCOUNT_STATE = {
  id: null,
  type: null,
};

const DEFAULT_CLIENT_ACCOUNT_STATE = {
  id: null,
  displayName: null,
  type: null,
  subscriptionInformation: {
    hasNoPreviousSubscription: true,
    hasTrialPeriod: false,
    freeTrialMonths: null,
  },
};

const BuySubscriptionForClient = () => {
  const growl = useContext(NotificationContext);
  const { aid: managingAccountId } = useParams();
  const { search } = useLocation();
  const { clientId } = qs.parse(search);

  const [managingAccount, setManagingAccount] = useState(DEFAULT_MANAGING_ACCOUNT_STATE);
  const [clientAccount, setClientAccount] = useState(DEFAULT_CLIENT_ACCOUNT_STATE);

  const { loading, error, data } = useQuery(BUY_OR_REACTIVATE_CONFIG_QUERY, {
    variables: {
      accountId: managingAccountId,
    },
    fetchPolicy: 'no-cache',
  });

  const { account: accountFromQuery } = data;

  useEffect(() => {
    if (accountFromQuery) {
      setManagingAccount({
        id: accountFromQuery.id,
        type: accountFromQuery.type,
      });

      setClientAccount(accountFromQuery.clientAccountsWithoutActiveSubscriptions.filter((a) => a.id === clientId)[0]);
    }
    // eslint-disable-next-line
  }, [accountFromQuery]);

  const dataIsLoading = loading || managingAccount === DEFAULT_MANAGING_ACCOUNT_STATE || clientAccount === DEFAULT_CLIENT_ACCOUNT_STATE;

  if (dataIsLoading) {
    return <Loading />;
  }

  if (error) {
    growlErrors(growl, error);
  }

  return <BuySubscription managingAccount={managingAccount} clientAccount={clientAccount} />;
};

export default BuySubscriptionForClient;
